export const THEME_COLOR = "#7338FF";

export const RUSD_FEATURES = [
  "持续收益，稳定运行",
  "团队合作，共享收益",
  "基于协议的奖励分配",
];

export const PROMOTION_ITEMS = [
  {
    icon: require("@/assets/image/tglm.png"),
    title: "推广联盟",
    desc: "层级奖励，团队奖励，业绩奖励，卡牌奖励",
  },
  {
    icon: require("@/assets/image/nftds.png"),
    title: "NFT大使",
    desc: "绩效奖励，代币赠送，全网分红，多节点奖励",
  },
];

export const ROADMAP_ITEMS = [
  {
    date: "6月",
    title: "新加坡基金会重启RAD生态",
    desc: "将底池逐步建立到500万枚BOX",
  },
  {
    date: "7月",
    title: "AI超级算法链上哈希策略全球公测",
    desc: "预计将获得基金会500-1000万美金支持",
  },
  {
    date: "8月",
    title: "合伙人NFT卡牌上线",
    desc: "三种等级卡牌上线抢购竞拍，销毁130万RAD",
    titleHighlight: true,
  },
  {
    date: "9月",
    title: "开通线上质押RAD与BOX",
    desc: "挖DEBOX稳定币，生态正式启动",
  },
  {
    date: "未来",
    title: "预计2027年年初上线中心化交易所",
    desc: "BNB CHAIN 币安交易所上线",
  },
];

export const PARTNERS_LIST = Array.from({ length: 12 }, (_, i) => ({
  id: i + 1,
  image: require(`@/assets/image/partner${i + 1}.png`),
}));
